import { networkCaches } from "@/cache/GlobalCache";
import type { LayerUnionWithAll } from "@/layers";
import type { JSONInitDate } from "@mm/api.meteomatics.com";

export function getInitDatePromise(layer: LayerUnionWithAll, validDate: Date): Promise<JSONInitDate> | null {
  if (layer && "model" in layer && "parameter_unit" in layer && "show_init_time" in layer && layer.model !== "mix") {
    const timeRelatedLayer = layer; // get the right layer types
    const parameter = timeRelatedLayer.parameter_unit;
    const model = timeRelatedLayer.model;
    return networkCaches.initDate_cache
      .retrieveInitDate({
        parameters: [parameter],
        model: model,
        validDate: validDate,
      })
      .asynchronous.then((initDate: JSONInitDate) => initDate);
  }
  return null;
}
